module.exports = __webpack_public_path__ + "img/di15.3392ed9c.png";